module.exports = __webpack_public_path__ + "static/media/ic_icon_1.9fd4521e.svg";